import React from 'react';
import { Github, Linkedin, Mail, GraduationCap } from 'lucide-react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    {
      name: 'GitHub',
      href: 'https://github.com/mike22g',
      icon: Github,
    },
    {
      name: 'LinkedIn',
      href: 'https://www.linkedin.com/in/michael-guevarra',
      icon: Linkedin,
    },
    {
      name: 'Google Scholar',
      href: 'https://scholar.google.com/citations?user=DswSo0MAAAAJ&hl=en',
      icon: GraduationCap,
    },
    {
      name: 'Email',
      href: 'mailto:michael@michaelguevarra.com',
      icon: Mail,
    },
  ];

  return (
    <footer className="bg-white/40 backdrop-blur-sm text-secondary-900">
      <div className="container-max section-padding">
        <div className="flex flex-col items-center space-y-6">
          {/* Social Links */}
          <div className="flex space-x-6">
            {socialLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className="text-secondary-600 hover:text-primary-600 transition-colors"
                aria-label={link.name}
              >
                <link.icon className="h-6 w-6" />
              </a>
            ))}
          </div>

          {/* Copyright */}
          <div className="text-center">
            <p className="text-secondary-500">
              © {currentYear} Michael Guevarra. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 